module.exports = __webpack_public_path__ + "img/questions.3285c07.png";